import React from 'react'

export const CustomLoading = () => <p>Loading...</p>
